<template>
    <v-card>
        <v-card-title>
            <div class="mr-3">{{$t('event.news')}}</div>
            {{"(Time Zone: "+THIS_PAGE_TIME_ZONE+")"}}
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="initAddNews">
                {{$t('add')}}
                <v-icon right>mdi-plus</v-icon>
            </v-btn>
        </v-card-title>
        <v-data-table
            :headers="headers"
            :items="newsItems"
            :loading="isNewsPending"
        >
            <template v-slot:item.scheduledAt="{value}">
                {{(value) ? DateTime.fromISO(value, {zone: THIS_PAGE_TIME_ZONE}).toFormat('yyyy-MM-dd HH:mm') : 'N/A'}}
            </template>
            <template v-slot:item.html_desc="{value}">
                <froalaView v-model="value" class="popup-preview"></froalaView>
            </template>
            <template v-slot:item.createdAt="{value}">
                {{DateTime.fromISO(value, {zone: THIS_PAGE_TIME_ZONE}).toFormat('yyyy-MM-dd HH:mm')}}
            </template>
            <template v-slot:item.updatedAt="{value}">
                {{DateTime.fromISO(value, {zone: THIS_PAGE_TIME_ZONE}).toFormat('yyyy-MM-dd HH:mm')}}
            </template>
            <template v-slot:item.feature="{value}">
                {{value.name}}
            </template>
            <template v-slot:item.actions="{item}">
                <v-btn color="primary" class="ma-2"
                       @click="initEditNews(item)">
                    {{$t('edit')}}
                    <v-icon right>mdi-pencil</v-icon>
                </v-btn>
                <v-btn color="red" dark class="ma-2"
                       @click="deleteNews(item)">
                    {{$t('delete')}}
                    <v-icon right>mdi-delete</v-icon>
                </v-btn>
            </template>
        </v-data-table>
        <v-dialog v-model="editNewsDialogShown"
            max-width="600px"
            persistent
            scrollable
            :retain-focus="false"
        >
            <v-card>
                <v-card-title>
                    {{$t('event.news')}}
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-form v-model="isEditNewsFormValid" ref="form">
                            <v-row>
                                <v-col class="py-0">{{$t('event_news.scheduled_at')}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col class="pt-2">
                                    <VueCtkDateTimePicker
                                        v-model="tempScheduledDateTime"
                                        format="YYYY-MM-DD HH:mm"
                                        noLabel
                                        :error="DTError"
                                    />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-text-field outlined
                                        :label="$t('event_news.title') + ' EN'"
                                        :placeholder="$t('event_news.title')"
                                        v-model="editingNews.title"
                                        :rules="required"
                                        hide-details
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">{{$t('event_news.html_desc')}} EN</v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <froala
                                        v-if="showEditor"
                                        :config="froalaConfig"
                                        v-model="editingNews.html_desc"
                                    ></froala>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-text-field outlined
                                        :label="$t('event_news.title') + ' TC'"
                                        :placeholder="$t('event_news.title')"
                                        v-model="editingNews.title__tc"
                                        hide-details
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">{{$t('event_news.html_desc')}} TC</v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <froala
                                        v-if="showEditor"
                                        :config="froalaConfig"
                                        v-model="editingNews.html_desc__tc"
                                    ></froala>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-text-field outlined
                                        :label="$t('event_news.title') + ' SC'"
                                        :placeholder="$t('event_news.title')"
                                        v-model="editingNews.title__sc"
                                        hide-details
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">{{$t('event_news.html_desc')}} SC</v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <froala
                                        v-if="showEditor"
                                        :config="froalaConfig"
                                        v-model="editingNews.html_desc__sc"
                                    ></froala>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-text-field outlined
                                        :label="$t('event_news.title') + ' ID'"
                                        :placeholder="$t('event_news.title')"
                                        v-model="editingNews.title__id"
                                        hide-details
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">{{$t('event_news.html_desc')}} ID</v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <froala
                                        v-if="showEditor"
                                        :config="froalaConfig"
                                        v-model="editingNews.html_desc__id"
                                    ></froala>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-text-field outlined
                                        :label="$t('event_news.title') + ' VN'"
                                        :placeholder="$t('event_news.title')"
                                        v-model="editingNews.title__vn"
                                        hide-details
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">{{$t('event_news.html_desc')}} VN</v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <froala
                                        v-if="showEditor"
                                        :config="froalaConfig"
                                        v-model="editingNews.html_desc__vn"
                                    ></froala>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-text-field outlined
                                        :label="$t('event_news.title') + ' FR'"
                                        :placeholder="$t('event_news.title')"
                                        v-model="editingNews.title__fr"
                                        hide-details
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">{{$t('event_news.html_desc')}} FR</v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <froala
                                        v-if="showEditor"
                                        :config="froalaConfig"
                                        v-model="editingNews.html_desc__fr"
                                    ></froala>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="secondary" @click="confirmCancelItemDialogShown = true">{{$t('cancel')}}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="submit">{{$t('save')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <PopupAlert 
            v-model="confirmCancelItemDialogShown"
            title="Warning"
            message="Do you wish to cancel your amendments?"
            :onYes="cancelEditNewsItem"
            :onNo="function() {confirmCancelItemDialogShown=false;}"
            ></PopupAlert>
        <PopupAlert 
            v-model="confirmSaveItemDialogShown"
            title="Confirm"
            message="Do you wish to confirm to send your news?"
            :onYes="saveNews"
            :onNo="function() {confirmSaveItemDialogShown=false;}"
            ></PopupAlert>
    </v-card>
</template>

<script>
    import {computed, ref, watch} from "@vue/composition-api";
    import {useFind} from "feathers-vuex";
    import {DateTime} from "luxon";
    import {cloneDeep} from "lodash";
    import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
    import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
    import PopupAlert from "../../components/PopupAlert";
    import froalaConfig from "../../froala-config";

    export default {
        name: 'EventNewsList',
        components:{VueCtkDateTimePicker,PopupAlert},
        setup(props, {root}) {
            const THIS_PAGE_TIME_ZONE = 'Asia/Hong_Kong';
            const {EventNews} = root.$FeathersVuex.api;

            const showEditor = ref(false);

            const eventId = computed(() => root.$route.params.eventId);

            const newsParams = computed(() => {
                return {
                    query: {
                        eventId: eventId.value,
                        $sort: {scheduledAt: -1},
                    }
                }
            });
            const {items: newsItems, isPending: isNewsPending} = useFind({
                model: EventNews,
                params: newsParams,
            });
            // Data Table
            const headers = ref([
                {text: root.$t('event_news.scheduled_at'), value: 'scheduledAt'},
                {text: root.$t('event_news.title'), value: 'title'},
                {text: root.$t('event_news.html_desc'), value: 'html_desc', width: '300px'},
                {text: '', value: 'actions'},
            ]);

            // Add / Edit News
            const editNewsDialogShown = ref(false);
            const confirmCancelItemDialogShown = ref(false);
            const confirmSaveItemDialogShown = ref(false);
            const isEditNewsFormValid = ref(false);
            const editingNews = ref(new EventNews({eventId: eventId.value}));
            const tempScheduledDateTime = ref("");
            const form = ref(null);
            const required = ref([]);
            const DTError = ref(false);

            const initAddNews = function () {
                editingNews.value = new EventNews({eventId: eventId.value});

                tempScheduledDateTime.value = ""
                // tempScheduledDate.value = null
                // tempScheduledTime.value = null
                
                editNewsDialogShown.value = true;
            };
            const initEditNews = function (news) {
                editingNews.value = cloneDeep(news);

                if (news.scheduledAt) {
                    const dateTime = DateTime.fromISO(news.scheduledAt, {zone: THIS_PAGE_TIME_ZONE});
                    const date = dateTime.toFormat('yyyy-MM-dd');
                    const time = dateTime.toFormat('HH:mm');
                    tempScheduledDateTime.value = date + " " + time
                } else {
                    tempScheduledDateTime.value = ""
                    // tempScheduledDate.value = null
                    // tempScheduledTime.value = null
                }

                editNewsDialogShown.value = true;
            };
            const deleteNews = function (news) {
                if (confirm(root.$t('event_news.confirm_delete'))) {
                    news.remove();
                }
            };
            const saveNews = async function () {
                editingNews.value.scheduledAt = DateTime.fromFormat(`${tempScheduledDateTime.value}`, 'yyyy-MM-dd HH:mm', {zone: THIS_PAGE_TIME_ZONE}).toISO();

                editingNews.value.save().then(() => {
                    EventNews.get(editingNews.value.id);
                    editNewsDialogShown.value = false;
                    confirmSaveItemDialogShown.value = false;
                    root.$store.dispatch('showSnackBar', root.$t('event_news.save_successful'));
                }, root.$handleFeatherError.bind(root));
            };

            const previewHtmlContentOption = {
                 modules: {
                    toolbar: false,
                },
                placeholder: '',
                theme: 'bubble',
            };

            watch(editNewsDialogShown, (newVal, oldVal) => {
                if ((!oldVal && newVal)) {
                    required.value = [];
                    form.value.resetValidation();
                    DTError.value = false;
                }
            })

            watch(tempScheduledDateTime, (newVal, oldVal) => {
                if (!oldVal && newVal) {
                    DTError.value = false;
                    return;
                }
            })

            const title = computed(() => editingNews.value.title);

            watch(title, () => {
                required.value = [];
            })

            const submit = () => {
                required.value = [
                    value => !!value || 'This field is required',
                ]
                if (!tempScheduledDateTime.value) {
                    DTError.value = true;
                }
                if (form.value.validate() && title.value && tempScheduledDateTime.value) {
                    confirmSaveItemDialogShown.value = true;
                }
            }

            const cancelEditNewsItem = function(){
                editNewsDialogShown.value = false;
                confirmCancelItemDialogShown.value = false;
            }
            return {
                newsItems,
                isNewsPending,

                THIS_PAGE_TIME_ZONE,
                headers,

                editNewsDialogShown,
                confirmCancelItemDialogShown,
                confirmSaveItemDialogShown,
                initAddNews,
                initEditNews,
                deleteNews,
                isEditNewsFormValid,
                editingNews,
                saveNews,
                cancelEditNewsItem,

                DateTime,
                getFileUrl: root.$getFileURL,

                previewHtmlContentOption,

                tempScheduledDateTime,
                required,
                form,
                DTError,
                submit,

                froalaConfig: {
                    ...froalaConfig,
                    toolbarSticky: false,
                    zIndex: 10
                },
                showEditor,
            }
        },
        mounted() {
            setTimeout(() => {
               this.showEditor = true;
            }, 100);
        }
    }
</script>
